/* eslint-disable */
import { useState, useEffect } from 'react';
import { proyekAPI } from '../services/api';
import { LoadingSpinner, ErrorBox, EmptyState } from '../components/LoadingSpinner';

// ============================================
// HELPERS
// ============================================
function formatRp(n) { return 'Rp ' + Number(n||0).toLocaleString('id-ID'); }
function formatRpSingkat(n) {
  const num = Number(n||0);
  if (num >= 1000000000) return 'Rp ' + (num/1000000000).toFixed(1) + ' M';
  if (num >= 1000000)    return 'Rp ' + (num/1000000).toFixed(0) + ' Jt';
  return formatRp(num);
}
function tglHariIni() { return new Date().toISOString().split('T')[0]; }

const inputStyle = {
  padding:'8px 10px', border:'1.5px solid #ddd', borderRadius:'8px',
  fontSize:'13px', color:'#333', background:'#fafafa',
  outline:'none', width:'100%', fontFamily:'inherit', boxSizing:'border-box'
};

function Modal({ show, onClose, title, children, footer, size='640px' }) {
  if (!show) return null;
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:999, padding:'20px' }}>
      <div style={{ background:'white', borderRadius:'16px', width:'100%', maxWidth:size, maxHeight:'90vh', display:'flex', flexDirection:'column', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'16px 24px', borderBottom:'1px solid #f0f4f8' }}>
          <h3 style={{ fontSize:'15px', color:'#1a3a5c', margin:0 }}>{title}</h3>
          <button onClick={onClose} style={{ background:'none', border:'none', fontSize:'20px', cursor:'pointer', color:'#888' }}>✕</button>
        </div>
        <div style={{ padding:'20px', overflowY:'auto', flex:1, display:'flex', flexDirection:'column', gap:'14px' }}>{children}</div>
        {footer && <div style={{ padding:'14px 20px', borderTop:'1px solid #f0f4f8', display:'flex', justifyContent:'flex-end', gap:'10px' }}>{footer}</div>}
      </div>
    </div>
  );
}

function Btn({ onClick, color='biru', children, disabled, size='normal' }) {
  const colors = {
    biru:  { bg:'linear-gradient(135deg,#1a3a5c,#2d6a9f)', txt:'white' },
    hijau: { bg:'linear-gradient(135deg,#1e8449,#27ae60)',  txt:'white' },
    merah: { bg:'linear-gradient(135deg,#c0392b,#e74c3c)',  txt:'white' },
    abu:   { bg:'white', txt:'#333', border:'1.5px solid #ddd' },
  };
  const c = colors[color];
  const pad = size==='small' ? '5px 12px' : '9px 16px';
  return (
    <button onClick={onClick} disabled={disabled} style={{ padding:pad, background:c.bg, color:c.txt, border:c.border||'none', borderRadius:'8px', fontSize: size==='small'?'12px':'13px', fontWeight:'600', cursor:disabled?'not-allowed':'pointer', opacity:disabled?0.6:1, whiteSpace:'nowrap' }}>
      {children}
    </button>
  );
}

function FG({ label, required, children, span }) {
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'6px', gridColumn: span?'1/-1':'auto' }}>
      <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>
        {label} {required && <span style={{ color:'#e74c3c' }}>*</span>}
      </label>
      {children}
    </div>
  );
}

function statusColor(status) {
  const map = {
    aktif:   { bg:'#eafaf1', color:'#27ae60', label:'🟢 Aktif'   },
    selesai: { bg:'#eaf0fb', color:'#2980b9', label:'✅ Selesai' },
    pending: { bg:'#fef5e7', color:'#e67e22', label:'⏸️ Pending' },
    belum:    { bg:'#f0f4f8', color:'#888',    label:'Belum'      },
    berjalan: { bg:'#fef5e7', color:'#e67e22', label:'Berjalan'   },
  };
  return map[status] || { bg:'#f0f4f8', color:'#666', label:status };
}

// ============================================
// TAB: DAFTAR PROYEK
// ============================================
function TabDaftarProyek({ user, onBukaDetail }) {
  const [list, setList]         = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({
    kode:'', nama:'', lokasi:'', nilai_kontrak:'', tgl_mulai:'', tgl_selesai:'', klien:'', pic:'', deskripsi:''
  });

  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    setLoading(true);
    try {
      const result = await proyekAPI.getAll();
      if (result.ok) setList(result.data.data); else setError(result.data.message);
    } catch(err) { setError('Gagal memuat data proyek'); }
    finally { setLoading(false); }
  }

  function handleChange(e) { setForm({...form, [e.target.name]: e.target.value}); }

  async function submitProyek() {
    if (!form.kode || !form.nama) { alert('⚠️ Kode dan nama proyek wajib diisi!'); return; }
    setSubmitting(true);
    try {
      const result = await proyekAPI.create({...form, nilai_kontrak: Number(form.nilai_kontrak||0)});
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowForm(false);
        setForm({ kode:'', nama:'', lokasi:'', nilai_kontrak:'', tgl_mulai:'', tgl_selesai:'', klien:'', pic:'', deskripsi:'' });
        fetchData();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  if (loading) return <LoadingSpinner pesan="Memuat daftar proyek..." />;
  if (error)   return <ErrorBox pesan={error} onRetry={fetchData} />;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

      {/* STAT RINGKAS */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'16px' }}>
        {[
          { icon:'📁', label:'Total Proyek',     val: list.length, bg:'linear-gradient(135deg,#1a3a5c,#2d6a9f)' },
          { icon:'🟢', label:'Proyek Aktif',     val: list.filter(p=>p.status==='aktif').length, bg:'linear-gradient(135deg,#1e8449,#27ae60)' },
          { icon:'💰', label:'Total Nilai Kontrak', val: formatRpSingkat(list.reduce((s,p)=>s+Number(p.nilai_kontrak||0),0)), bg:'linear-gradient(135deg,#6c3483,#8e44ad)' },
          { icon:'📊', label:'Progress Rata-rata', val: (list.length>0 ? Math.round(list.reduce((s,p)=>s+Number(p.progress_rab||0),0)/list.length) : 0)+'%', bg:'linear-gradient(135deg,#ca6f1e,#e67e22)' },
        ].map((s,i)=>(
          <div key={i} style={{ background:s.bg, borderRadius:'12px', padding:'20px', color:'white', display:'flex', flexDirection:'column', gap:'6px' }}>
            <span style={{ fontSize:'20px' }}>{s.icon}</span>
            <span style={{ fontSize:'22px', fontWeight:'700' }}>{s.val}</span>
            <span style={{ fontSize:'12px', opacity:0.85 }}>{s.label}</span>
          </div>
        ))}
      </div>

      {/* TOOLBAR */}
      <div style={{ display:'flex', justifyContent:'flex-end' }}>
        <Btn onClick={()=>setShowForm(true)}>+ Tambah Proyek Baru</Btn>
      </div>

      {/* GRID KARTU PROYEK */}
      {list.length === 0 ? (
        <EmptyState icon="📁" judul="Belum ada proyek" sub="Klik '+ Tambah Proyek Baru' untuk memulai" />
      ) : (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(340px,1fr))', gap:'16px' }}>
          {list.map(p=>{
            const prog  = Number(p.progress_rab||0);
            const sc    = statusColor(p.status);
            const totalRAB = Number(p.total_rab||0);
            const realisasi = Number(p.total_realisasi||0);
            return (
              <div key={p.id} onClick={()=>onBukaDetail(p.id)}
                style={{ background:'white', borderRadius:'12px', padding:'20px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)', cursor:'pointer', transition:'transform 0.15s, box-shadow 0.15s', border:'1px solid transparent' }}
                onMouseEnter={e=>{ e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.12)'; }}
                onMouseLeave={e=>{ e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.boxShadow='0 2px 8px rgba(0,0,0,0.06)'; }}
              >
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'12px' }}>
                  <div>
                    <div style={{ fontSize:'11px', color:'#888', fontWeight:'700' }}>{p.kode}</div>
                    <h4 style={{ fontSize:'15px', fontWeight:'700', color:'#1a3a5c', margin:'2px 0 0' }}>{p.nama}</h4>
                  </div>
                  <span style={{ padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background:sc.bg, color:sc.color, whiteSpace:'nowrap' }}>{sc.label}</span>
                </div>

                <div style={{ display:'flex', flexDirection:'column', gap:'4px', marginBottom:'12px', fontSize:'12px', color:'#666' }}>
                  <div>📍 {p.lokasi || '-'}</div>
                  <div>👤 {p.pic || '-'}</div>
                  <div>💰 {formatRp(p.nilai_kontrak)}</div>
                </div>

                {/* PROGRESS */}
                <div>
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'4px' }}>
                    <span style={{ fontSize:'11px', color:'#888' }}>Progress (dari realisasi RAB)</span>
                    <span style={{ fontSize:'13px', fontWeight:'700', color: prog>=100?'#27ae60': prog>=75?'#2980b9': prog>=50?'#e67e22':'#e74c3c' }}>{prog}%</span>
                  </div>
                  <div style={{ background:'#f0f4f8', borderRadius:'99px', height:'8px', overflow:'hidden' }}>
                    <div style={{ width:`${prog}%`, height:'100%', background: prog>=100?'#27ae60': prog>=75?'#2980b9': prog>=50?'#e67e22':'#e74c3c', borderRadius:'99px', transition:'width 0.5s' }} />
                  </div>
                  <div style={{ display:'flex', justifyContent:'space-between', marginTop:'4px', fontSize:'10px', color:'#999' }}>
                    <span>RAB: {formatRpSingkat(totalRAB)}</span>
                    <span>Realisasi: {formatRpSingkat(realisasi)}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* MODAL FORM PROYEK */}
      <Modal show={showForm} onClose={()=>setShowForm(false)} title="📁 Tambah Proyek Baru"
        footer={<>
          <Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn>
          <Btn onClick={submitProyek} disabled={submitting}>{submitting?'⏳...':'✅ Simpan Proyek'}</Btn>
        </>}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' }}>
          <FG label="Kode Proyek" required>
            <input name="kode" value={form.kode} onChange={handleChange} placeholder="PRJ-005" style={inputStyle} />
          </FG>
          <FG label="Nilai Kontrak (Rp)">
            <input type="number" name="nilai_kontrak" value={form.nilai_kontrak} onChange={handleChange} placeholder="0" style={inputStyle} />
          </FG>
          <FG label="Nama Proyek" required span>
            <input name="nama" value={form.nama} onChange={handleChange} placeholder="Nama proyek" style={inputStyle} />
          </FG>
          <FG label="Lokasi">
            <input name="lokasi" value={form.lokasi} onChange={handleChange} placeholder="Kota/lokasi" style={inputStyle} />
          </FG>
          <FG label="Klien / Pemberi Kerja">
            <input name="klien" value={form.klien} onChange={handleChange} placeholder="Nama klien" style={inputStyle} />
          </FG>
          <FG label="Tanggal Mulai">
            <input type="date" name="tgl_mulai" value={form.tgl_mulai} onChange={handleChange} style={inputStyle} />
          </FG>
          <FG label="Tanggal Selesai">
            <input type="date" name="tgl_selesai" value={form.tgl_selesai} onChange={handleChange} style={inputStyle} />
          </FG>
          <FG label="PIC / Manajer Proyek" span>
            <input name="pic" value={form.pic} onChange={handleChange} placeholder="Nama PIC" style={inputStyle} />
          </FG>
          <FG label="Deskripsi" span>
            <textarea name="deskripsi" value={form.deskripsi} onChange={handleChange} rows="3" style={{ ...inputStyle, resize:'vertical' }} />
          </FG>
        </div>
      </Modal>
    </div>
  );
}

// ============================================
// DETAIL PROYEK (RAB, Milestone, Dokumen)
// ============================================
function DetailProyek({ proyekId, user, onKembali }) {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [tabDetail, setTabDetail] = useState('rab');
  const [showFormRAB, setShowFormRAB] = useState(false);
  const [editRealisasi, setEditRealisasi] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const [formRAB, setFormRAB] = useState({ kode:'', uraian:'', kategori:'', volume:'', satuan:'', harga_satuan:'' });
  const [realisasiVal, setRealisasiVal] = useState('');

  useEffect(() => { fetchDetail(); }, [proyekId]);

  async function fetchDetail() {
    setLoading(true);
    try {
      const result = await proyekAPI.getById(proyekId);
      if (result.ok) setData(result.data.data);
    } catch(err) {}
    finally { setLoading(false); }
  }

  async function submitRAB() {
    if (!formRAB.uraian) { alert('⚠️ Uraian wajib diisi!'); return; }
    setSubmitting(true);
    try {
      const result = await proyekAPI.createRAB({ ...formRAB, proyek_id: proyekId, volume: Number(formRAB.volume||0), harga_satuan: Number(formRAB.harga_satuan||0) });
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowFormRAB(false);
        setFormRAB({ kode:'', uraian:'', kategori:'', volume:'', satuan:'', harga_satuan:'' });
        fetchDetail();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  async function simpanRealisasi(rabId) {
    setSubmitting(true);
    try {
      const result = await proyekAPI.updateRealisasiRAB(rabId, Number(realisasiVal||0));
      if (result.ok) {
        setEditRealisasi(null);
        setRealisasiVal('');
        fetchDetail();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal'); }
    finally { setSubmitting(false); }
  }

  if (loading) return <LoadingSpinner pesan="Memuat detail proyek..." />;
  if (!data) return null;

  const totalRAB     = (data.rab||[]).reduce((s,r)=>s+Number(r.total||0),0);
  const totalReal    = (data.rab||[]).reduce((s,r)=>s+Number(r.realisasi_rp||0),0);
  const progressRAB  = totalRAB > 0 ? Math.round(totalReal/totalRAB*100) : 0;

  const thS = { padding:'8px 10px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center', background:'#f0f4f8', whiteSpace:'nowrap' };
  const tdS = { border:'1px solid #ddd', padding:'8px 10px', fontSize:'12px' };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

      {/* HEADER DETAIL */}
      <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
        <button onClick={onKembali} style={{ background:'white', border:'1.5px solid #ddd', borderRadius:'8px', padding:'8px 14px', cursor:'pointer', fontSize:'13px', fontWeight:'600', color:'#666' }}>
          ← Kembali
        </button>
        <div>
          <div style={{ fontSize:'11px', color:'#888', fontWeight:'700' }}>{data.kode}</div>
          <h2 style={{ fontSize:'18px', fontWeight:'700', color:'#1a3a5c', margin:0 }}>{data.nama}</h2>
        </div>
      </div>

      {/* INFO CARDS */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'16px' }}>
        {[
          { label:'Nilai Kontrak',  val: formatRpSingkat(data.nilai_kontrak), icon:'💰' },
          { label:'Total RAB',      val: formatRpSingkat(totalRAB), icon:'📋' },
          { label:'Realisasi',      val: formatRpSingkat(totalReal), icon:'✅' },
          { label:'Progress',       val: progressRAB+'%', icon:'📊' },
        ].map((c,i)=>(
          <div key={i} style={{ background:'white', borderRadius:'12px', padding:'16px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
            <div style={{ fontSize:'20px', marginBottom:'4px' }}>{c.icon}</div>
            <div style={{ fontSize:'18px', fontWeight:'700', color:'#1a3a5c' }}>{c.val}</div>
            <div style={{ fontSize:'11px', color:'#888' }}>{c.label}</div>
          </div>
        ))}
      </div>

      {/* PROGRESS BAR BESAR */}
      <div style={{ background:'white', borderRadius:'12px', padding:'16px 20px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'6px' }}>
          <span style={{ fontSize:'13px', fontWeight:'600', color:'#333' }}>Progress Fisik Proyek (otomatis dari realisasi RAB)</span>
          <span style={{ fontSize:'15px', fontWeight:'700', color:'#2d6a9f' }}>{progressRAB}%</span>
        </div>
        <div style={{ background:'#f0f4f8', borderRadius:'99px', height:'12px', overflow:'hidden' }}>
          <div style={{ width:`${progressRAB}%`, height:'100%', background:'linear-gradient(90deg,#2d6a9f,#5ba3d9)', borderRadius:'99px', transition:'width 0.5s' }} />
        </div>
      </div>

      {/* TAB DETAIL */}
      <div style={{ display:'flex', gap:'8px', background:'white', padding:'8px', borderRadius:'12px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
        {[
          { id:'rab',       label:'📋 RAB & Realisasi' },
          { id:'milestone', label:'🎯 Milestone' },
          { id:'dokumen',   label:'📎 Dokumen' },
        ].map(t=>(
          <button key={t.id} onClick={()=>setTabDetail(t.id)} style={{
            padding:'8px 16px', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer',
            background: tabDetail===t.id?'#1a3a5c':'transparent', color: tabDetail===t.id?'white':'#888',
          }}>{t.label}</button>
        ))}
      </div>

      {/* TAB RAB */}
      {tabDetail==='rab' && (
        <div style={{ background:'white', borderRadius:'12px', padding:'20px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px' }}>
            <h3 style={{ fontSize:'14px', fontWeight:'700', color:'#1a3a5c', margin:0 }}>📋 Rencana Anggaran Biaya (RAB)</h3>
            <Btn onClick={()=>setShowFormRAB(true)} size="small">+ Tambah Item RAB</Btn>
          </div>

          {(data.rab||[]).length === 0 ? (
            <EmptyState icon="📋" judul="Belum ada RAB" sub="Tambahkan item RAB untuk mulai tracking progress" />
          ) : (
            <div style={{ overflowX:'auto' }}>
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <thead>
                  <tr>
                    {['Kode','Uraian','Kategori','Volume','Sat','Harga Satuan','Total','Bobot','Realisasi Vol','Realisasi Rp','%','Aksi'].map(h=>(
                      <th key={h} style={thS}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.rab.map(r=>{
                    const persen = Number(r.total)>0 ? Math.round(Number(r.realisasi_rp)/Number(r.total)*100) : 0;
                    return (
                      <tr key={r.id}>
                        <td style={{ ...tdS, textAlign:'center', fontWeight:'700' }}>{r.kode}</td>
                        <td style={{ ...tdS }}>{r.uraian}</td>
                        <td style={{ ...tdS, textAlign:'center' }}>{r.kategori}</td>
                        <td style={{ ...tdS, textAlign:'center' }}>{Number(r.volume).toLocaleString('id-ID')}</td>
                        <td style={{ ...tdS, textAlign:'center' }}>{r.satuan}</td>
                        <td style={{ ...tdS, textAlign:'right' }}>{formatRp(r.harga_satuan)}</td>
                        <td style={{ ...tdS, textAlign:'right', fontWeight:'600' }}>{formatRp(r.total)}</td>
                        <td style={{ ...tdS, textAlign:'center', color:'#888' }}>{Number(r.bobot).toFixed(1)}%</td>
                        <td style={{ ...tdS, textAlign:'center' }}>
                          {editRealisasi===r.id ? (
                            <input type="number" value={realisasiVal} onChange={e=>setRealisasiVal(e.target.value)}
                              placeholder={r.realisasi_vol} autoFocus
                              style={{ ...inputStyle, padding:'4px 6px', width:'70px', textAlign:'center' }} />
                          ) : (
                            <span>{Number(r.realisasi_vol).toLocaleString('id-ID')}</span>
                          )}
                        </td>
                        <td style={{ ...tdS, textAlign:'right', color:'#27ae60', fontWeight:'600' }}>{formatRp(r.realisasi_rp)}</td>
                        <td style={{ ...tdS, textAlign:'center' }}>
                          <div style={{ display:'flex', alignItems:'center', gap:'4px', justifyContent:'center' }}>
                            <div style={{ background:'#f0f4f8', borderRadius:'99px', height:'6px', width:'40px', overflow:'hidden' }}>
                              <div style={{ width:`${Math.min(100,persen)}%`, height:'100%', background: persen>=100?'#27ae60':'#e67e22' }} />
                            </div>
                            <span style={{ fontSize:'11px' }}>{persen}%</span>
                          </div>
                        </td>
                        <td style={{ ...tdS, textAlign:'center' }}>
                          {editRealisasi===r.id ? (
                            <div style={{ display:'flex', gap:'4px' }}>
                              <button onClick={()=>simpanRealisasi(r.id)} disabled={submitting} style={{ background:'#27ae60', color:'white', border:'none', borderRadius:'4px', padding:'4px 8px', cursor:'pointer', fontSize:'11px' }}>✓</button>
                              <button onClick={()=>{ setEditRealisasi(null); setRealisasiVal(''); }} style={{ background:'#e74c3c', color:'white', border:'none', borderRadius:'4px', padding:'4px 8px', cursor:'pointer', fontSize:'11px' }}>✕</button>
                            </div>
                          ) : (
                            <button onClick={()=>{ setEditRealisasi(r.id); setRealisasiVal(String(r.realisasi_vol)); }}
                              style={{ background:'#eaf0fb', color:'#2d6a9f', border:'none', borderRadius:'4px', padding:'4px 10px', cursor:'pointer', fontSize:'11px', fontWeight:'600' }}>
                              ✏️ Update
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                  {/* TOTAL */}
                  <tr style={{ background:'#f0f4f8' }}>
                    <td colSpan={6} style={{ ...tdS, textAlign:'center', fontWeight:'700', letterSpacing:'1px' }}>TOTAL</td>
                    <td style={{ ...tdS, textAlign:'right', fontWeight:'700', color:'#1a3a5c' }}>{formatRp(totalRAB)}</td>
                    <td style={{ ...tdS, textAlign:'center', fontWeight:'700' }}>100%</td>
                    <td style={tdS}></td>
                    <td style={{ ...tdS, textAlign:'right', fontWeight:'700', color:'#27ae60' }}>{formatRp(totalReal)}</td>
                    <td style={{ ...tdS, textAlign:'center', fontWeight:'700', color:'#2d6a9f' }}>{progressRAB}%</td>
                    <td style={tdS}></td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* TAB MILESTONE */}
      {tabDetail==='milestone' && (
        <div style={{ background:'white', borderRadius:'12px', padding:'20px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
          <h3 style={{ fontSize:'14px', fontWeight:'700', color:'#1a3a5c', marginBottom:'16px', marginTop:0 }}>🎯 Milestone & Timeline</h3>
          {(data.milestone||[]).length === 0 ? (
            <EmptyState icon="🎯" judul="Belum ada milestone" sub="Tambahkan milestone untuk tracking tahapan" />
          ) : (
            <div style={{ display:'flex', flexDirection:'column', gap:'0' }}>
              {data.milestone.map((m,i)=>{
                const sc = statusColor(m.status);
                const isLast = i === data.milestone.length-1;
                return (
                  <div key={m.id} style={{ display:'flex', gap:'16px' }}>
                    {/* Timeline dot & line */}
                    <div style={{ display:'flex', flexDirection:'column', alignItems:'center' }}>
                      <div style={{ width:'32px', height:'32px', borderRadius:'50%', background: m.status==='selesai'?'#27ae60': m.status==='berjalan'?'#e67e22':'#ddd', color:'white', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'700', fontSize:'13px', flexShrink:0 }}>
                        {m.status==='selesai'?'✓':i+1}
                      </div>
                      {!isLast && <div style={{ width:'2px', flex:1, background:'#e0e8f4', minHeight:'30px' }} />}
                    </div>
                    {/* Content */}
                    <div style={{ flex:1, paddingBottom:'20px' }}>
                      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                        <div>
                          <h4 style={{ fontSize:'14px', fontWeight:'700', color:'#1a3a5c', margin:'0 0 2px' }}>{m.nama}</h4>
                          <div style={{ fontSize:'11px', color:'#888' }}>
                            {m.tgl_mulai?.split('T')[0]} → {m.tgl_selesai?.split('T')[0]} · Bobot {Number(m.bobot)}%
                          </div>
                        </div>
                        <span style={{ padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background:sc.bg, color:sc.color }}>{sc.label}</span>
                      </div>
                      <div style={{ marginTop:'8px' }}>
                        <div style={{ background:'#f0f4f8', borderRadius:'99px', height:'6px', overflow:'hidden' }}>
                          <div style={{ width:`${m.progress}%`, height:'100%', background: m.status==='selesai'?'#27ae60':'#e67e22', borderRadius:'99px' }} />
                        </div>
                        <span style={{ fontSize:'11px', color:'#888' }}>{m.progress}% selesai</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* TAB DOKUMEN */}
      {tabDetail==='dokumen' && (
        <div style={{ background:'white', borderRadius:'12px', padding:'20px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
          <h3 style={{ fontSize:'14px', fontWeight:'700', color:'#1a3a5c', marginBottom:'16px', marginTop:0 }}>📎 Dokumen Proyek</h3>
          {(data.dokumen||[]).length === 0 ? (
            <EmptyState icon="📎" judul="Belum ada dokumen" sub="Dokumen kontrak, SPK, gambar akan muncul di sini" />
          ) : (
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))', gap:'12px' }}>
              {data.dokumen.map(d=>(
                <div key={d.id} style={{ border:'1px solid #e0e8f4', borderRadius:'10px', padding:'14px', textAlign:'center' }}>
                  <div style={{ fontSize:'32px', marginBottom:'6px' }}>
                    {d.tipe==='kontrak'?'📄': d.tipe==='spk'?'📝': d.tipe==='gambar'?'🖼️':'📎'}
                  </div>
                  <div style={{ fontSize:'12px', fontWeight:'600', color:'#333', marginBottom:'2px' }}>{d.nama}</div>
                  <div style={{ fontSize:'10px', color:'#888' }}>{d.tipe} · {d.ukuran}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* MODAL FORM RAB */}
      <Modal show={showFormRAB} onClose={()=>setShowFormRAB(false)} title="📋 Tambah Item RAB"
        footer={<>
          <Btn color="abu" onClick={()=>setShowFormRAB(false)} disabled={submitting}>Batal</Btn>
          <Btn onClick={submitRAB} disabled={submitting}>{submitting?'⏳...':'✅ Simpan'}</Btn>
        </>}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' }}>
          <FG label="Kode"><input value={formRAB.kode} onChange={e=>setFormRAB({...formRAB,kode:e.target.value})} placeholder="A.8" style={inputStyle} /></FG>
          <FG label="Kategori">
            <select value={formRAB.kategori} onChange={e=>setFormRAB({...formRAB,kategori:e.target.value})} style={inputStyle}>
              <option value="">-- Pilih --</option>
              {['Persiapan','Struktur','Arsitektur','MEP','Finishing','Lainnya'].map(k=><option key={k} value={k}>{k}</option>)}
            </select>
          </FG>
          <FG label="Uraian Pekerjaan" required span>
            <input value={formRAB.uraian} onChange={e=>setFormRAB({...formRAB,uraian:e.target.value})} placeholder="Pekerjaan..." style={inputStyle} />
          </FG>
          <FG label="Volume"><input type="number" value={formRAB.volume} onChange={e=>setFormRAB({...formRAB,volume:e.target.value})} placeholder="0" style={inputStyle} /></FG>
          <FG label="Satuan"><input value={formRAB.satuan} onChange={e=>setFormRAB({...formRAB,satuan:e.target.value})} placeholder="m³, m², ls" style={inputStyle} /></FG>
          <FG label="Harga Satuan (Rp)" span>
            <input type="number" value={formRAB.harga_satuan} onChange={e=>setFormRAB({...formRAB,harga_satuan:e.target.value})} placeholder="0" style={inputStyle} />
          </FG>
          {formRAB.volume && formRAB.harga_satuan && (
            <div style={{ gridColumn:'1/-1', padding:'12px', background:'#f8fbff', borderRadius:'8px', display:'flex', justifyContent:'space-between' }}>
              <span style={{ fontSize:'13px', fontWeight:'600' }}>Total:</span>
              <strong style={{ color:'#1a3a5c' }}>{formatRp(Number(formRAB.volume)*Number(formRAB.harga_satuan))}</strong>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
}

// ============================================
// TAB: LAPORAN
// ============================================
function TabLaporan({ user }) {
  const [list, setList]         = useState([]);
  const [loading, setLoading]   = useState(true);
  const [filterTipe, setFilterTipe] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const proyekList = [
    { id:1, nama:'Gedung Kantor Surabaya' },
    { id:2, nama:'Renovasi RSUD Sidoarjo' },
    { id:3, nama:'Jalan Lingkar Gresik'   },
    { id:4, nama:'Tower Apartemen Malang'  },
  ];

  const [form, setForm] = useState({
    proyek_id:'', tipe:'harian', tanggal:tglHariIni(), periode_dari:'', periode_sampai:'',
    cuaca:'Cerah', progress_fisik:'', jml_pekerja:'',
    uraian_kegiatan:'', kendala:'', rencana_besok:'', material_masuk:''
  });

  useEffect(() => { fetchData(); }, [filterTipe]);

  async function fetchData() {
    setLoading(true);
    try {
      const result = await proyekAPI.getLaporan(filterTipe ? { tipe: filterTipe } : {});
      if (result.ok) setList(result.data.data);
    } catch(err) {}
    finally { setLoading(false); }
  }

  function handleChange(e) { setForm({...form, [e.target.name]: e.target.value}); }

  async function submitLaporan() {
    if (!form.proyek_id || !form.tanggal) { alert('⚠️ Proyek dan tanggal wajib diisi!'); return; }
    setSubmitting(true);
    try {
      const result = await proyekAPI.createLaporan({ ...form, proyek_id: Number(form.proyek_id), progress_fisik: Number(form.progress_fisik||0), jml_pekerja: Number(form.jml_pekerja||0) });
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowForm(false);
        setForm({ proyek_id:'', tipe:'harian', tanggal:tglHariIni(), periode_dari:'', periode_sampai:'', cuaca:'Cerah', progress_fisik:'', jml_pekerja:'', uraian_kegiatan:'', kendala:'', rencana_besok:'', material_masuk:'' });
        fetchData();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  const tipeBadge = (tipe) => {
    const map = { harian:{bg:'#eafaf1',color:'#27ae60',label:'📅 Harian'}, mingguan:{bg:'#fef5e7',color:'#e67e22',label:'📆 Mingguan'}, bulanan:{bg:'#eaf0fb',color:'#2980b9',label:'🗓️ Bulanan'} };
    const m = map[tipe] || {bg:'#f0f4f8',color:'#666',label:tipe};
    return <span style={{ padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background:m.bg, color:m.color }}>{m.label}</span>;
  };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <select value={filterTipe} onChange={e=>setFilterTipe(e.target.value)} style={{ ...inputStyle, maxWidth:'180px' }}>
          <option value="">Semua Tipe</option>
          <option value="harian">Harian</option>
          <option value="mingguan">Mingguan</option>
          <option value="bulanan">Bulanan</option>
        </select>
        <Btn onClick={()=>setShowForm(true)}>+ Buat Laporan</Btn>
      </div>

      {loading ? <LoadingSpinner pesan="Memuat laporan..." /> : (
        list.length === 0
          ? <EmptyState icon="📝" judul="Belum ada laporan" sub="Klik '+ Buat Laporan' untuk membuat laporan proyek" />
          : (
            <div style={{ background:'white', borderRadius:'12px', overflow:'hidden', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <thead>
                  <tr style={{ borderBottom:'2px solid #f0f4f8' }}>
                    {['No. Laporan','Tipe','Tanggal','Proyek','Progress','Pekerja','Cuaca','Dibuat','Aksi'].map(h=>(
                      <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'10px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {list.map(l=>(
                    <tr key={l.id} style={{ borderBottom:'1px solid #f5f7fa' }}>
                      <td style={{ padding:'12px', fontSize:'13px' }}><strong>{l.no_laporan}</strong></td>
                      <td style={{ padding:'12px' }}>{tipeBadge(l.tipe)}</td>
                      <td style={{ padding:'12px', fontSize:'12px' }}>{l.tanggal?.split('T')[0]}</td>
                      <td style={{ padding:'12px', fontSize:'12px' }}>{l.nama_proyek}</td>
                      <td style={{ padding:'12px', fontSize:'13px', fontWeight:'600', color:'#2d6a9f' }}>{l.progress_fisik}%</td>
                      <td style={{ padding:'12px', fontSize:'12px' }}>{l.jml_pekerja} org</td>
                      <td style={{ padding:'12px', fontSize:'12px' }}>{l.cuaca}</td>
                      <td style={{ padding:'12px', fontSize:'12px', color:'#888' }}>{l.nama_pembuat}</td>
                      <td style={{ padding:'12px' }}>
                        <button onClick={()=>setShowDetail(l)} style={{ padding:'5px 12px', background:'#eaf0fb', color:'#2d6a9f', border:'none', borderRadius:'6px', fontSize:'12px', fontWeight:'600', cursor:'pointer' }}>Detail</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
      )}

      {/* MODAL FORM LAPORAN */}
      <Modal show={showForm} onClose={()=>setShowForm(false)} title="📝 Buat Laporan Proyek"
        footer={<>
          <Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn>
          <Btn onClick={submitLaporan} disabled={submitting}>{submitting?'⏳...':'✅ Simpan Laporan'}</Btn>
        </>}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' }}>
          <FG label="Proyek" required>
            <select name="proyek_id" value={form.proyek_id} onChange={handleChange} style={inputStyle}>
              <option value="">-- Pilih --</option>
              {proyekList.map(p=><option key={p.id} value={p.id}>{p.nama}</option>)}
            </select>
          </FG>
          <FG label="Tipe Laporan" required>
            <select name="tipe" value={form.tipe} onChange={handleChange} style={inputStyle}>
              <option value="harian">📅 Harian</option>
              <option value="mingguan">📆 Mingguan</option>
              <option value="bulanan">🗓️ Bulanan</option>
            </select>
          </FG>
          <FG label="Tanggal" required>
            <input type="date" name="tanggal" value={form.tanggal} onChange={handleChange} style={inputStyle} />
          </FG>
          <FG label="Cuaca">
            <select name="cuaca" value={form.cuaca} onChange={handleChange} style={inputStyle}>
              {['Cerah','Berawan','Hujan Ringan','Hujan Deras','Mendung'].map(c=><option key={c} value={c}>{c}</option>)}
            </select>
          </FG>
          <FG label="Progress Fisik (%)">
            <input type="number" name="progress_fisik" value={form.progress_fisik} onChange={handleChange} placeholder="0" min="0" max="100" style={inputStyle} />
          </FG>
          <FG label="Jumlah Pekerja">
            <input type="number" name="jml_pekerja" value={form.jml_pekerja} onChange={handleChange} placeholder="0" style={inputStyle} />
          </FG>
          <FG label="Uraian Kegiatan" span>
            <textarea name="uraian_kegiatan" value={form.uraian_kegiatan} onChange={handleChange} rows="3" placeholder="Kegiatan yang dilakukan hari ini..." style={{ ...inputStyle, resize:'vertical' }} />
          </FG>
          <FG label="Material Masuk" span>
            <textarea name="material_masuk" value={form.material_masuk} onChange={handleChange} rows="2" placeholder="Material yang diterima..." style={{ ...inputStyle, resize:'vertical' }} />
          </FG>
          <FG label="Kendala">
            <textarea name="kendala" value={form.kendala} onChange={handleChange} rows="2" placeholder="Kendala di lapangan..." style={{ ...inputStyle, resize:'vertical' }} />
          </FG>
          <FG label="Rencana Besok">
            <textarea name="rencana_besok" value={form.rencana_besok} onChange={handleChange} rows="2" placeholder="Rencana kegiatan berikutnya..." style={{ ...inputStyle, resize:'vertical' }} />
          </FG>
        </div>
      </Modal>

      {/* MODAL DETAIL LAPORAN */}
      <Modal show={!!showDetail} onClose={()=>setShowDetail(null)} title={`Laporan — ${showDetail?.no_laporan}`}
        footer={<Btn color="abu" onClick={()=>setShowDetail(null)}>Tutup</Btn>}>
        {showDetail && (
          <div style={{ display:'flex', flexDirection:'column', gap:'14px' }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'10px' }}>
              {[['Tipe',showDetail.tipe],['Tanggal',showDetail.tanggal?.split('T')[0]],['Proyek',showDetail.nama_proyek],['Progress',showDetail.progress_fisik+'%'],['Pekerja',showDetail.jml_pekerja+' org'],['Cuaca',showDetail.cuaca]].map(([l,v])=>(
                <div key={l}><p style={{ fontSize:'11px', color:'#888', fontWeight:'700', margin:'0 0 2px' }}>{l}</p><p style={{ fontSize:'13px', margin:0 }}>{v}</p></div>
              ))}
            </div>
            {[['📋 Uraian Kegiatan',showDetail.uraian_kegiatan],['📦 Material Masuk',showDetail.material_masuk],['⚠️ Kendala',showDetail.kendala],['📅 Rencana Berikutnya',showDetail.rencana_besok]].map(([l,v])=>(
              v && <div key={l}>
                <p style={{ fontSize:'12px', fontWeight:'700', color:'#1a3a5c', margin:'0 0 4px' }}>{l}</p>
                <p style={{ fontSize:'13px', color:'#555', margin:0, background:'#f8fbff', padding:'10px', borderRadius:'8px' }}>{v}</p>
              </div>
            ))}
          </div>
        )}
      </Modal>
    </div>
  );
}

// ============================================
// KOMPONEN UTAMA: PROYEK
// ============================================
function Proyek({ user }) {
  const [tabAktif, setTabAktif]     = useState('daftar');
  const [detailId, setDetailId]     = useState(null);

  return (
    <div style={{ display:'flex', flexDirection:'column' }}>
      <header style={{ display:'flex', justifyContent:'space-between', alignItems:'center', background:'white', padding:'14px 24px', borderBottom:'1px solid #e8edf2', position:'sticky', top:0, zIndex:10 }}>
        <div>
          <h1 style={{ fontSize:'18px', fontWeight:'700', color:'#1a3a5c', margin:0 }}>Manajemen Proyek</h1>
          <span style={{ fontSize:'12px', color:'#888' }}>Daftar Proyek · RAB · Progress · Laporan</span>
        </div>
        <div style={{ fontSize:'13px', color:'#666' }}>👤 {user?.nama} — {user?.role}</div>
      </header>

      <div style={{ padding:'24px', display:'flex', flexDirection:'column', gap:'20px' }}>
        {!detailId && (
          <div style={{ display:'flex', gap:'8px', background:'white', padding:'8px', borderRadius:'12px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
            {[{ id:'daftar', label:'📁 Daftar Proyek' }, { id:'laporan', label:'📝 Laporan Proyek' }].map(t=>(
              <button key={t.id} onClick={()=>setTabAktif(t.id)} style={{
                padding:'10px 20px', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer',
                background: tabAktif===t.id?'#1a3a5c':'transparent', color: tabAktif===t.id?'white':'#888',
              }}>{t.label}</button>
            ))}
          </div>
        )}

        {detailId ? (
          <DetailProyek proyekId={detailId} user={user} onKembali={()=>setDetailId(null)} />
        ) : (
          <>
            {tabAktif==='daftar'  && <TabDaftarProyek user={user} onBukaDetail={setDetailId} />}
            {tabAktif==='laporan' && <TabLaporan user={user} />}
          </>
        )}
      </div>
    </div>
  );
}

export default Proyek;